import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import { DataGridPro } from '@mui/x-data-grid-pro'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

const InfoRequest = ({data, open, setOpen}) => {
    const { t } = useTranslation('request.form.info_request')

    const closing = () => {
        setOpen(false)
    }

    const columns = useMemo(() => [
        { field: 'date', headerName: t('info_request.table.columns.date'), flex: 1 },
        { field: 'status', headerName: t('info_request.table.columns.status'), flex: 1 },
        { field: 'paycode', headerName: t('info_request.table.columns.paycode'), flex: 1 },
        { field: 'message', headerName: t('info_request.table.columns.message'), flex: 2 },
    ], [t])

    return (
        <>
            <Dialog
                open={open}
                onClose={() => closing()}
                fullWidth
            >
                <DialogTitle>
                    <Typography variant='body3'>{ t('info_request.title') }</Typography>
                </DialogTitle>

                <DialogContent dividers>
                    <DataGridPro 
                        showCellVerticalBorder
                        showColumnVerticalBorder
                        //unstable_headerFilters
                        loading={false}
                        columns={columns}
                        rows={ data?.kronos_response ?
                            JSON.parse(data?.kronos_response).map(response  => ({
                                id: data.id,
                                date: `${response.schedule?.start_date} ${response.schedule?.end_date}`,
                                status: response.status,
                                paycode: response.schedule?.paycode,
                                message: response.message
                            }))
                            : 
                            []
                        }
                        sx={{minHeight: 100}}
                        hideFooter
                    />
                </DialogContent>

                <DialogActions>
                    <Button
                        variant='contained'
                        disableElevation
                        onClick={() => closing()}
                        color='error'
                        sx={{mr: 2}}
                    >
                        { t('info_request.buttons.close') }
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export {
    InfoRequest
}